import { render, staticRenderFns } from "./ChargeGrossMargin.vue?vue&type=template&id=59a04c31&scoped=true&"
import script from "./ChargeGrossMargin.vue?vue&type=script&lang=js&"
export * from "./ChargeGrossMargin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a04c31",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59a04c31')) {
      api.createRecord('59a04c31', component.options)
    } else {
      api.reload('59a04c31', component.options)
    }
    module.hot.accept("./ChargeGrossMargin.vue?vue&type=template&id=59a04c31&scoped=true&", function () {
      api.rerender('59a04c31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Act/chargeSummary/ChargeGrossMargin.vue"
export default component.exports